<div class="d-block">
  <router-outlet></router-outlet>

  <app-centralized-module-processes></app-centralized-module-processes>

  <app-alter></app-alter>

  <p-dialog
    [visible]="mfaOtpPrompt.visible"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: 'min(460px, 94vw)' }"
    appendTo="body"
    styleClass="mfa-sensitive-actions-dialog"
    header="MFA Verification">
    <form class="login-form-dialog-mfa mt-2" ngNativeValidate="false" (ngSubmit)="onMfaSensitiveSubmit()">
      <p class="f-14 _fw-600 mb-0 mt-3" *ngIf="mfaOtpPrompt.message">{{ mfaOtpPrompt.message }}</p>

      <p class="f-13 mb-0 mt-2" *ngIf="mfaLoggedInUserName()">
        Signed in as <b>{{ mfaLoggedInUserName() }}</b
        >. Enter this account's MFA code.
      </p>

      <ng-container *ngIf="mfaOtpPrompt.authentication_type === 'email-authenticator'; else globalMfaAppHint">
        <p class="f-18 _fw-600 mt-3">We sent an OTP code to your email</p>

        <p class="f-14 mt-3">
          To continue, please enter the 6-digit verification code sent to <b>your email {{ mfaOtpPrompt.emailMasked }}</b>
        </p>
      </ng-container>

      <ng-template #globalMfaAppHint>
        <p class="f-12">
          <ng-container *ngIf="mfaOtpPrompt.authentication_type === 'google-authenticator'">
            Open Google Authenticator and enter the code.
          </ng-container>

          <ng-container *ngIf="mfaOtpPrompt.authentication_type === 'microsoft-authenticator'">
            Open Microsoft Authenticator and enter the code.
          </ng-container>

          <ng-container *ngIf="mfaOtpPrompt.authentication_type === 'authy-authenticator'">Open Authy and enter the code.</ng-container>

          <ng-container
            *ngIf="
              mfaOtpPrompt.authentication_type &&
              mfaOtpPrompt.authentication_type !== 'google-authenticator' &&
              mfaOtpPrompt.authentication_type !== 'microsoft-authenticator' &&
              mfaOtpPrompt.authentication_type !== 'authy-authenticator'
            ">
            <b>Please enter the 6-digit MFA code using your {{ mfaOtpType() }}</b>
          </ng-container>

          <ng-container *ngIf="!mfaOtpPrompt.authentication_type">
            <b>Please enter your 6-digit MFA code</b>
          </ng-container>
        </p>
      </ng-template>

      <app-input-one-time-password name="sensitiveActionMfaOtp" [(ngModel)]="mfaOtpPrompt.otpInput" [size]="6"></app-input-one-time-password>

      <p class="text-danger mt-3 f-12" *ngIf="mfaOtpPrompt.authentication_type === 'email-authenticator'">
        IMPORTANT: MFA via email is no longer supported; please choose an alternative authentication method.
      </p>

      <div class="mt-4 d-flex justify-content-end align-items-center flex-wrap" style="gap: 12px">
        <button type="button" class="_cancel-btn" (click)="mfaOtpPrompt.cancelFromDialog()">Cancel</button>

        <button type="submit" class="_primary-btn" [disabled]="!canSubmitSensitiveMfa()">Verify</button>
      </div>
    </form>
  </p-dialog>

  <div *ngIf="isUpdatePromptVisible && isUserLoggedIn()" class="app-update-toast" role="status" aria-live="polite">
    <div class="app-update-card" role="dialog" aria-labelledby="app-update-title" aria-describedby="app-update-message">
      <div class="app-update-header">
        <div class="app-update-icon">
          <i class="pi pi-refresh"></i>
        </div>

        <div class="app-update-content">
          <p class="app-update-eyebrow">Update available</p>

          <h2 id="app-update-title">New changes are ready</h2>
        </div>
      </div>

      <div class="app-update-body">
        <p id="app-update-message">A new version of Remmi has been deployed. Refresh now to load the latest changes.</p>
      </div>

      <div class="app-update-actions">
        <button type="button" class="app-update-secondary-btn" (click)="dismissUpdatePrompt()">Later</button>

        <button type="button" class="app-update-primary-btn" (click)="refreshApplication()">
          <i class="pi pi-refresh"></i>

          Refresh now
        </button>
      </div>
    </div>
  </div>
</div>
